
// --- Vue & Template imports ---
import { Component, Vue} from 'vue-property-decorator';

// --- Models ---

// --- Services ---
import AppService from '@/services/app';
import JobCardService from '@/services/jobCard';
import VehicleService from '@/services/vehicle';

// --- Third Party ---
import dayjs from 'dayjs';

@Component
export default class WorkshopSummaryPage extends Vue {
  isLoading: boolean = true;
  cols: number = 6;

  // !!TODO #120 2024 New Feature: Link Trailers

  // #region Functions to display list data on page load
    async beforeMount() {
      await AppService.listStatuses(false);
      await VehicleService.listTypes(false);
      await JobCardService.listOpen(true);
      await this.listWorkshopSummary(true);

      /*
        Column Rules:
        6 OR 4 OR 3 OR 2
      */
      this.cols = 4;
    }

    async listWorkshopSummary(refreshFromAPI: boolean) {
      try {
        this.isLoading = true;

        const response: string = await VehicleService.listWorkshopSummary(refreshFromAPI);

        if (response.length > 0 && response !== 'No Data Found') {
          AppService.errorHandler(response);
        }

      } finally {
        this.isLoading = false;
      }
    }

    getJobDate(startDate: string) {
      return dayjs(startDate).format('DD/MM').toUpperCase();
    }
  // #endregion
}
